import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'



import Home from '../components/home.vue'
import parkingServices from '../components/parkingServices.vue'
import accessControll from '../components/accessControll.vue'
import fitness from '../components/fitness.vue'
import sensor from '../components/sensor.vue'
import blog from '../components/blog.vue'
import blogDetails from '../components/blogDetails.vue'
import clients from '../components/clients.vue'
import contact from '../components/contact.vue'



const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },    
    {
        path: '/accessControll',
        name: 'accessControll',
        component: accessControll
    },      
    {
        path: '/fitness',
        name: 'fitness',
        component: fitness
    },      
    {
        path: '/sensor',
        name: 'sensor',
        component: sensor
    },     
    {
        path: '/parkingServices',
        name: 'parkingServices',
        component: parkingServices
    },     
    {
        path: '/blog',
        name: 'blog',
        component: blog
    },    
    {
        path: '/blogDetails/:slug',
        name: 'blogDetails',
        component: blogDetails
    },
    {
        path: '/clients',
        name: 'clients',
        component: clients
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact
    }

   
]



const router = createRouter({

    history: createWebHistory(),

    routes,

    scrollBehavior(to) {

        if (to.hash) {

            return {
                el: to.hash,
                behavior: 'smooth'
            }

        }

        return {
            top: 0
        }

    }

});


//const router = createRouter({ history: createWebHistory(), routes })
export default router